<template>
  <div v-show = "fieldData.isShow == 1||fieldData.fieldType == 'groupTitle'">
    <div style = "width:100%;" v-if = 'fieldData.fieldType == "groupTitle"' v-html = "fieldData.fieldName"></div>
    <VerifyField v-else :isVertical = 'isVertical' :isPreview = 'isPreview' ref = 'itemField' :fieldData = 'fieldData' :allFieldsVal='allFieldsVal' :doubleCallFlag='doubleCallFlag' :auoHeight = "(fieldData.fieldType == '15'||fieldData.fieldType == '16')">
      <ItemField v-if = "fieldData.fieldType != '14'&&fieldData.fieldType != '15'&&fieldData.fieldType != '16'" @change = '_onchange' :fieldData = "fieldData" :allFieldsVal='allFieldsVal' :doubleCallFlag='doubleCallFlag' :val = "fieldData.val"  />
      <DivCompent v-else-if="fieldData.fieldType == '14'" :fieldData = "fieldData" :defaultValue="fieldData.value" @change="_val => areaChange(fieldData,_val)"/>
      <div v-else-if = "fieldData.fieldType == '16'">
        <Upload 
          v-if = "fieldData.picUploadNum >= ids.split(',').length"
          class="upload-16"
          :format= '["jpg", "png", "txt", "doc", "docx", "wps", "mp4", "rm", "rmvb", "mpeg", "avi", "xls", "xlsx", "gif", "zip", "mov", "jpeg"]'
          multiple
          :with-credentials = 'true'
          :max-size="10240"
          :on-exceeded-size= "handleErrorSize"
          :on-format-error= "handleError"
          style="display:inline-block;width:100%;"
          :action="customFileUrl"
          :data="{data: fieldData}"
          :show-upload-list="false"
          :before-upload= "handleBeforeUpload"
          :on-success= "handleFileSuccess"
        >
          <Button style = "border:1px solid #ddd;" icon="ios-cloud-upload-outline">{{fieldData.fieldName}}</Button>
        </Upload>
        <div style = 'padding-top:10px;margin-left:-10px;'>
          <CFileField @on-delete = "handleRemoveUploadFile" :dele = 'true' :ids = 'ids' />
        </div>
      </div>
      <div v-else-if = "fieldData.fieldType == '15'">
        <!-- <p v-for="item in fileList" :key="item">{{item}}</p> -->
        <div style = 'display:inline-block;padding-left:5px;'>
            <div class="demo-upload-list" v-for="(item,index) in fileList" :key = "index" >
                <img :src="`${envConst['API_BASE_URL']}/file/filemanage/downloadFileById/${item}`">
                <!-- https://sczd.pointlinkprox.com/file/filemanage/downloadFileById/67e4d4f9e39f48c384a2cd0fdf24512f -->
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(item,index)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="handleRemoveUploadFile(item)"></Icon>
                </div>
            </div>

            
            
        </div> 
        <Upload 
          v-if = "fieldData.picUploadNum>=fileList.length"
          class="upload-16"
          :format= '["jpg", "png", "gif", "jpeg"]'
          multiple
          type="drag"
          :with-credentials = 'true'
          :max-size="10240"
          :on-exceeded-size= "handleErrorSize"
          :on-format-error= "handleError"
          :action="customFileUrl"
          :data="{data: fieldData}"
          :show-upload-list="false"
          :before-upload= "handleBeforeUpload"
          :on-success= "handleFileSuccess"
          style="display: inline-block;width:58px;"
        >
          <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <Modal v-model="visible">
                <img :src="viewImg" v-if="visible" style="width: 100%; max-height:600px">
            </Modal>
      </div>
    </VerifyField>
  </div>
</template>

<script>
import ItemField from './dynamicFieldConditionsComponent.vue'
import DivCompent from "../renderNodeCascad.vue"
import VerifyField from './verifyField.vue'
import envConst from '../../../env-const.js'
export default {
  props: ['fieldData','isPreview','isVertical','allFieldsVal','doubleCallFlag'],
  data(){
    return {
      customFileUrl: '',
      envConst,
      rules: [],
      visible: false,
      viewImg: '',
      files: [],
      // fileList: []
    }
  },
  // watch:{
  //   'fieldData.value': {
  //     handler(newValue){
  //       this.fileList = (this.fieldData.value?this.fieldData.value.split(','):[]);
  //     },
  //     deep:true
  //   }
  // },
  created(){
    this.customFileUrl = envConst.API_BASE_URL + '/file/filemanage/uploadFile/' + this.getUuid()
  },
  computed: {
    fileList(){
      return this.fieldData.value?this.fieldData.value.split(','):[]
    },
    ids(){
      return this.fieldData.value
    }
  },
  methods: {
    _reset(){
      this.$refs['itemField']._reset()
    },
    handleView(item,index){
      this.viewImg = `${this.envConst['API_BASE_URL']}/file/filemanage/downloadFileById/${item}`
      this.$nextTick(()=>{
        this.visible = true
      })
    },
    _onchange(field){
      // console.log(field)
      this.$emit('change',field)
    },
    areaChange(item,_val){
      if(_val.flag){ // 如果省市区为空，则文本框不能有值
        item.flag = true
      }
      item.fieldValue = _val.value
      this.$emit('change',item)
    },
    verify(){
      return this.$refs['itemField'].verify()
    },
    //文件上传前
    handleBeforeUpload(){

    },
    //文件上传成功
    handleFileSuccess(data,file,fielList){
      console.log(data,file)
      if(data.returnCode == 0){
        let fileListArr = this.fieldData.value?this.fieldData.value.split(','):[]
        fileListArr.push(data.bean.attachmentId)
        this.fieldData.value = fileListArr.join(',')
        this.$Message.success('上传成功')
      }else{
        this.$Message.error(data.returnMessage)
      }
    },
    //文件删除
    handleRemoveUploadFile(id){
      console.log(id)
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除？',
        onOk: ()=>{
          this.$http
          .get(
            envConst.API_BASE_URL +
              '/file/filemanage/deleteFileById/' +
              id
          )
          .then(response => {
            if (response.data.returnCode == 0) {
              this.$Message.success('删除成功')
              let fileListArr = this.fieldData.value?this.fieldData.value.split(','):[]
              fileListArr.splice(fileListArr.indexOf(id),1)
              this.fieldData.value = fileListArr.join(',')
            } else {
              this.$Message.error(response.data.returnMessage)
            }
          })
          .catch(error => {
            this.$Message.error('删除发生错误')
          })
        },
        onCancel:()=>{
          
        }
      })
    },
    //文件大小校验
    handleErrorSize(){

    },
    handleError(){

    },
    //生成随机数
    getUuid() {
      return (
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre()
      )
    },
    uuIdPre() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
  },
  components: {
    ItemField,
    VerifyField,
    DivCompent
  }
}
</script>

<style lang = "less" scoped>
.demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
}
.demo-upload-list img{
    width: 100%;
    height: 100%;
}
.demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
}
.demo-upload-list:hover .demo-upload-list-cover{
    display: block;
}
.demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
    }
</style>